import { defineMessages } from 'react-intl';

export default defineMessages({
    leastCoverage: {
        id: 'ml.quoteandbind.customcomponent.rangeslider.leastCoverage',
        defaultMessage: 'Least\nCoverage'
    },
    lessCoverage: {
        id: 'ml.quoteandbind.customcomponent.rangeslider.lessCoverage',
        defaultMessage: 'Less\nCoverage'
    },
    recommendedCoverage: {
        id: 'ml.quoteandbind.customcomponent.rangeslider.recommendedCoverage',
        defaultMessage: 'Recommended\nCoverage'
    },
    moreCoverage: {
        id: 'ml.quoteandbind.customcomponent.rangeslider.moreCoverage',
        defaultMessage: 'More\nCoverage'
    },
    mostCoverage: {
        id: 'ml.quoteandbind.customcomponent.rangeslider.mostCoverage',
        defaultMessage: 'Most\nCoverage'
    },
    perMonth: {
        id: 'ml.quoteandbind.customcomponent.rangeslider.perMonth',
        defaultMessage: '/month'
    }
});
